"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironment = exports.isProdEnvironment = exports.isProductiveEnvironment = exports.isPreEnvironment = exports.ENVIRONMENT_LIST = exports.PRO_ENVIRONMENT_LIST = exports.PRE_ENVIRONMENT_LIST = exports.PROD_ENVIRONMENT = exports.SHA_ENVIRONMENT = exports.OCU_ENVIRONMENT = exports.PRE_ENVIRONMENT = exports.STG_ENVIRONMENT = exports.QA_ENVIRONMENT = exports.DEV_ENVIRONMENT = void 0;
exports.DEV_ENVIRONMENT = 'dev';
exports.QA_ENVIRONMENT = 'qa';
exports.STG_ENVIRONMENT = 'stg';
exports.PRE_ENVIRONMENT = 'pre';
exports.OCU_ENVIRONMENT = 'ocu';
exports.SHA_ENVIRONMENT = 'sha';
exports.PROD_ENVIRONMENT = 'prod';
exports.PRE_ENVIRONMENT_LIST = [exports.DEV_ENVIRONMENT, exports.QA_ENVIRONMENT, exports.STG_ENVIRONMENT, exports.PRE_ENVIRONMENT];
exports.PRO_ENVIRONMENT_LIST = [exports.OCU_ENVIRONMENT, exports.SHA_ENVIRONMENT, exports.PROD_ENVIRONMENT];
exports.ENVIRONMENT_LIST = [...exports.PRE_ENVIRONMENT_LIST, ...exports.PROD_ENVIRONMENT];
const isPreEnvironment = () => exports.PRE_ENVIRONMENT_LIST.includes(window.ENVIRONMENT);
exports.isPreEnvironment = isPreEnvironment;
const isProductiveEnvironment = () => exports.PRO_ENVIRONMENT_LIST.includes(window.ENVIRONMENT);
exports.isProductiveEnvironment = isProductiveEnvironment;
const isProdEnvironment = () => exports.PROD_ENVIRONMENT === window.ENVIRONMENT;
exports.isProdEnvironment = isProdEnvironment;
const getEnvironment = () => window.ENVIRONMENT;
exports.getEnvironment = getEnvironment;
//# sourceMappingURL=environment.utils.js.map